import API from '../../shared/Config/API';
import APIEndpoints from '../../shared/Config/APIEndpoints';

const fetchAllRules = async () => {
  try {
    return await API.get(APIEndpoints.FETCH_ALL_RULES);
  } catch (error) {
    console.error(error);
  }
};
export const RulesAPI = {
  fetchAllRules,
};
